/**
 * Friendly display labels for the rembrandt memory taxonomy. The collection is
 * python-owned and may add types over time, so `memoryTypeLabel` falls back to
 * a Title-cased version of the raw snake_case key rather than rendering the
 * raw value or `undefined`.
 */
export const MEMORY_TYPE_LABELS: Record<string, string> = {
  approval_precedent: "Approval Precedent",
  asset_specifications: "Asset Specifications",
  brand_identity: "Brand Identity",
  competitive_context: "Competitive Context",
  decision_log: "Decision Log",
  institutional_context: "Institutional Context",
  mistake_registry: "Mistake Registry",
  pattern_library: "Pattern Library",
  regulatory_compliance: "Regulatory Compliance",
  stakeholder_model: "Stakeholder Model",
  terminology_glossary: "Terminology Glossary",
  trigger: "Trigger",
  user_preference: "User Preference",
};

/** Title-case an unknown snake_case type as a fallback. */
function titleCase(raw: string): string {
  return raw
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

export function memoryTypeLabel(type: string): string {
  if (!type) return "Unknown";
  return MEMORY_TYPE_LABELS[type] ?? titleCase(type);
}
